var map = {
	"./Avatare-01.webp": 3116,
	"./Avatare-02.webp": 3833,
	"./Avatare-03.webp": 4110,
	"./Avatare-04.webp": 8499,
	"./Avatare-05.webp": 6288,
	"./Avatare-06.webp": 4189,
	"./Avatare-07.webp": 7778,
	"./Avatare-08.webp": 9991,
	"./Avatare-09.webp": 8132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8471;